import { Application } from "stimulus"
import { registerControllers } from 'stimulus-vite-helpers'
import StimulusReflex from 'stimulus_reflex'
import consumer from '../channels/consumer'
import controller from '../controllers/application_controller'

const application = Application.start()
const context = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, context)
application.consumer = consumer
StimulusReflex.initialize(application, { controller, isolate: true })
StimulusReflex.debug = import.meta.env.MODE === 'development';
